import classNames from 'classnames';
import type React from 'react';
import type { FC } from 'react';
import { Text } from '../../atoms/text/text';
import utilityStyles from '../../theme/utilities.module.scss';
import type { Colors } from '../../types/colors';
import styles from './footnote.module.scss';

export type FootnoteProps = {
  children: React.ReactNode;
  className?: string;
  color?: Colors;
  index: string | number;
};

export const Footnote: FC<FootnoteProps> = ({ children, className, color, index }) => (
  <Text
    className={classNames('footnote', styles.footnote, color && utilityStyles[`theme-color-${color}`], className)}
    renderAs="div"
    size="xs"
  >
    <sup>{index}</sup>
    <div>{children}</div>
  </Text>
);
